export default function genererCritereRechercheEcranNumeriqueByBailleur() {
  return {
    auto: null,
    societeId: null,
    tiersIds: [],
    codesMateriel: [],
    codesBail: [],
    formatsId: [],
    typesMateriel: [],
    codesDispositif: [],
    typesDispositif: [],
    typesSupport: [],
    etatsMateriel: [],
    datesMontage: null,
    datesDemontage: null,
    adresse: null,
    villes: [],
    agglomerations: [],
    actif: true,
  };
}
